var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.show)?_c('b-row',{staticStyle:{"width":"100%"}},_vm._l((_vm.widgets),function(item,index){return _c(item,{key:("dashboard-widget-" + index),tag:"component"})})):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b843228","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Dashboard.vue
// module id = 832
// module chunks = 1